import _definePage_default_0 from 'D:/Repositorys/Unsedang/unsedang-cli/pages/auth/kakao/callback.vue?definePage&vue&lang.tsx'
import { _mergeRouteRecord } from 'unplugin-vue-router/runtime'
import _definePage_default_2 from 'D:/Repositorys/Unsedang/unsedang-cli/pages/auth/naver/callback.vue?definePage&vue&lang.tsx'

export const routes = [
  {
    path: '/ai-note',
    /* internal name: '/ai-note' */
    /* no component */
    children: [
      {
        path: '',
        name: '/ai-note/',
        component: () => import('D:/Repositorys/Unsedang/unsedang-cli/pages/ai-note/index.vue'),
        /* no children */
      },
      {
        path: 'noteInfo',
        name: '/ai-note/noteInfo',
        component: () => import('D:/Repositorys/Unsedang/unsedang-cli/pages/ai-note/noteInfo.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/appleJoin',
    name: '/appleJoin',
    component: () => import('D:/Repositorys/Unsedang/unsedang-cli/pages/appleJoin.vue'),
    /* no children */
  },
  {
    path: '/auth',
    /* internal name: '/auth' */
    /* no component */
    children: [
      {
        path: 'apple',
        /* internal name: '/auth/apple' */
        /* no component */
        children: [
          {
            path: 'callback',
            name: '/auth/apple/callback',
            component: () => import('D:/Repositorys/Unsedang/unsedang-cli/pages/auth/apple/callback.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'kakao',
        /* internal name: '/auth/kakao' */
        /* no component */
        children: [
          _mergeRouteRecord(
            {
              path: 'callback',
              name: '/auth/kakao/callback',
              component: () => import('D:/Repositorys/Unsedang/unsedang-cli/pages/auth/kakao/callback.vue'),
              /* no children */
            },
            _definePage_default_0
          )
        ],
      },
      {
        path: 'naver',
        /* internal name: '/auth/naver' */
        /* no component */
        children: [
          _mergeRouteRecord(
            {
              path: 'callback',
              name: '/auth/naver/callback',
              component: () => import('D:/Repositorys/Unsedang/unsedang-cli/pages/auth/naver/callback.vue'),
              /* no children */
            },
            _definePage_default_2
          )
        ],
      }
    ],
  },
  {
    path: '/bujeok',
    /* internal name: '/bujeok' */
    /* no component */
    children: [
      {
        path: '',
        name: '/bujeok/',
        component: () => import('D:/Repositorys/Unsedang/unsedang-cli/pages/bujeok/index.vue'),
        /* no children */
      },
      {
        path: 'order',
        name: '/bujeok/order',
        component: () => import('D:/Repositorys/Unsedang/unsedang-cli/pages/bujeok/order.vue'),
        /* no children */
      },
      {
        path: 'product',
        name: '/bujeok/product',
        component: () => import('D:/Repositorys/Unsedang/unsedang-cli/pages/bujeok/product.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/chat',
    name: '/chat',
    component: () => import('D:/Repositorys/Unsedang/unsedang-cli/pages/chat.vue'),
    /* no children */
  },
  {
    path: '/chatMypage',
    name: '/chatMypage',
    component: () => import('D:/Repositorys/Unsedang/unsedang-cli/pages/chatMypage.vue'),
    /* no children */
  },
  {
    path: '/chatRoomList',
    name: '/chatRoomList',
    component: () => import('D:/Repositorys/Unsedang/unsedang-cli/pages/chatRoomList.vue'),
    /* no children */
  },
  {
    path: '/content',
    /* internal name: '/content' */
    /* no component */
    children: [
      {
        path: '',
        name: '/content/',
        component: () => import('D:/Repositorys/Unsedang/unsedang-cli/pages/content/index.vue'),
        /* no children */
      },
      {
        path: 'sidoList',
        name: '/content/sidoList',
        component: () => import('D:/Repositorys/Unsedang/unsedang-cli/pages/content/sidoList.vue'),
        /* no children */
      },
      {
        path: 'sigunguList',
        name: '/content/sigunguList',
        component: () => import('D:/Repositorys/Unsedang/unsedang-cli/pages/content/sigunguList.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/createChat',
    name: '/createChat',
    component: () => import('D:/Repositorys/Unsedang/unsedang-cli/pages/createChat.vue'),
    /* no children */
  },
  {
    path: '/csl',
    /* internal name: '/csl' */
    /* no component */
    children: [
      {
        path: '',
        name: '/csl/',
        component: () => import('D:/Repositorys/Unsedang/unsedang-cli/pages/csl/index.vue'),
        /* no children */
      },
      {
        path: 'catCsl',
        name: '/csl/catCsl',
        component: () => import('D:/Repositorys/Unsedang/unsedang-cli/pages/csl/catCsl.vue'),
        /* no children */
      },
      {
        path: 'cslInfo',
        name: '/csl/cslInfo',
        component: () => import('D:/Repositorys/Unsedang/unsedang-cli/pages/csl/cslInfo.vue'),
        /* no children */
      },
      {
        path: 'newsInfo',
        name: '/csl/newsInfo',
        component: () => import('D:/Repositorys/Unsedang/unsedang-cli/pages/csl/newsInfo.vue'),
        /* no children */
      },
      {
        path: 'totalNews',
        name: '/csl/totalNews',
        component: () => import('D:/Repositorys/Unsedang/unsedang-cli/pages/csl/totalNews.vue'),
        /* no children */
      },
      {
        path: 'totalRatingComment',
        name: '/csl/totalRatingComment',
        component: () => import('D:/Repositorys/Unsedang/unsedang-cli/pages/csl/totalRatingComment.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/event',
    /* internal name: '/event' */
    /* no component */
    children: [
      {
        path: 'e4',
        name: '/event/e4',
        component: () => import('D:/Repositorys/Unsedang/unsedang-cli/pages/event/e4.vue'),
        /* no children */
      },
      {
        path: 'e5',
        name: '/event/e5',
        component: () => import('D:/Repositorys/Unsedang/unsedang-cli/pages/event/e5.vue'),
        /* no children */
      },
      {
        path: 'event30Csl',
        name: '/event/event30Csl',
        component: () => import('D:/Repositorys/Unsedang/unsedang-cli/pages/event/event30Csl.vue'),
        /* no children */
      },
      {
        path: 'eventJoin5000',
        name: '/event/eventJoin5000',
        component: () => import('D:/Repositorys/Unsedang/unsedang-cli/pages/event/eventJoin5000.vue'),
        /* no children */
      },
      {
        path: 'EventList',
        name: '/event/EventList',
        component: () => import('D:/Repositorys/Unsedang/unsedang-cli/pages/event/EventList.vue'),
        /* no children */
      },
      {
        path: 'Promotion',
        name: '/event/Promotion',
        component: () => import('D:/Repositorys/Unsedang/unsedang-cli/pages/event/Promotion.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/fiId',
    name: '/fiId',
    component: () => import('D:/Repositorys/Unsedang/unsedang-cli/pages/fiId.vue'),
    /* no children */
  },
  {
    path: '/fiPw',
    name: '/fiPw',
    component: () => import('D:/Repositorys/Unsedang/unsedang-cli/pages/fiPw.vue'),
    /* no children */
  },
  {
    path: '/fortune',
    /* internal name: '/fortune' */
    /* no component */
    children: [
      {
        path: '',
        name: '/fortune/',
        component: () => import('D:/Repositorys/Unsedang/unsedang-cli/pages/fortune/index.vue'),
        /* no children */
      },
      {
        path: 'fortuneCookie',
        name: '/fortune/fortuneCookie',
        component: () => import('D:/Repositorys/Unsedang/unsedang-cli/pages/fortune/fortuneCookie.vue'),
        /* no children */
      },
      {
        path: 'historyToday',
        name: '/fortune/historyToday',
        component: () => import('D:/Repositorys/Unsedang/unsedang-cli/pages/fortune/historyToday.vue'),
        /* no children */
      },
      {
        path: 'luckyColor',
        name: '/fortune/luckyColor',
        component: () => import('D:/Repositorys/Unsedang/unsedang-cli/pages/fortune/luckyColor.vue'),
        /* no children */
      },
      {
        path: 'luckyItem',
        name: '/fortune/luckyItem',
        component: () => import('D:/Repositorys/Unsedang/unsedang-cli/pages/fortune/luckyItem.vue'),
        /* no children */
      },
      {
        path: 'share',
        /* internal name: '/fortune/share' */
        /* no component */
        children: [
          {
            path: 'fortuneCookie',
            name: '/fortune/share/fortuneCookie',
            component: () => import('D:/Repositorys/Unsedang/unsedang-cli/pages/fortune/share/fortuneCookie.vue'),
            /* no children */
          },
          {
            path: 'historyToday',
            name: '/fortune/share/historyToday',
            component: () => import('D:/Repositorys/Unsedang/unsedang-cli/pages/fortune/share/historyToday.vue'),
            /* no children */
          },
          {
            path: 'luckyColor',
            name: '/fortune/share/luckyColor',
            component: () => import('D:/Repositorys/Unsedang/unsedang-cli/pages/fortune/share/luckyColor.vue'),
            /* no children */
          },
          {
            path: 'luckyItem',
            name: '/fortune/share/luckyItem',
            component: () => import('D:/Repositorys/Unsedang/unsedang-cli/pages/fortune/share/luckyItem.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'unseMonth',
        name: '/fortune/unseMonth',
        component: () => import('D:/Repositorys/Unsedang/unsedang-cli/pages/fortune/unseMonth.vue'),
        /* no children */
      },
      {
        path: 'unseToday',
        name: '/fortune/unseToday',
        component: () => import('D:/Repositorys/Unsedang/unsedang-cli/pages/fortune/unseToday.vue'),
        /* no children */
      },
      {
        path: 'unseYear',
        name: '/fortune/unseYear',
        component: () => import('D:/Repositorys/Unsedang/unsedang-cli/pages/fortune/unseYear.vue'),
        /* no children */
      },
      {
        path: 'unseZodiac',
        name: '/fortune/unseZodiac',
        component: () => import('D:/Repositorys/Unsedang/unsedang-cli/pages/fortune/unseZodiac.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/free',
    /* internal name: '/free' */
    /* no component */
    children: [
      {
        path: '',
        name: '/free/',
        component: () => import('D:/Repositorys/Unsedang/unsedang-cli/pages/free/index.vue'),
        /* no children */
      },
      {
        path: 'freeEdit',
        name: '/free/freeEdit',
        component: () => import('D:/Repositorys/Unsedang/unsedang-cli/pages/free/freeEdit.vue'),
        /* no children */
      },
      {
        path: 'freeInfo',
        name: '/free/freeInfo',
        component: () => import('D:/Repositorys/Unsedang/unsedang-cli/pages/free/freeInfo.vue'),
        /* no children */
      },
      {
        path: 'registrationEnd',
        name: '/free/registrationEnd',
        component: () => import('D:/Repositorys/Unsedang/unsedang-cli/pages/free/registrationEnd.vue'),
        /* no children */
      },
      {
        path: 'registrationForm',
        name: '/free/registrationForm',
        component: () => import('D:/Repositorys/Unsedang/unsedang-cli/pages/free/registrationForm.vue'),
        /* no children */
      },
      {
        path: 'registrationStart',
        name: '/free/registrationStart',
        component: () => import('D:/Repositorys/Unsedang/unsedang-cli/pages/free/registrationStart.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/gdn',
    /* internal name: '/gdn' */
    /* no component */
    children: [
      {
        path: '',
        name: '/gdn/',
        component: () => import('D:/Repositorys/Unsedang/unsedang-cli/pages/gdn/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/home',
    /* internal name: '/home' */
    /* no component */
    children: [
      {
        path: '',
        name: '/home/',
        component: () => import('D:/Repositorys/Unsedang/unsedang-cli/pages/home/index.vue'),
        /* no children */
      },
      {
        path: 'sections',
        /* internal name: '/home/sections' */
        /* no component */
        children: [
          {
            path: 'AvailableNowCounselors',
            name: '/home/sections/AvailableNowCounselors',
            component: () => import('D:/Repositorys/Unsedang/unsedang-cli/pages/home/sections/AvailableNowCounselors.vue'),
            /* no children */
          },
          {
            path: 'GuestPromoBanner',
            name: '/home/sections/GuestPromoBanner',
            component: () => import('D:/Repositorys/Unsedang/unsedang-cli/pages/home/sections/GuestPromoBanner.vue'),
            /* no children */
          },
          {
            path: 'LikedCounselors',
            name: '/home/sections/LikedCounselors',
            component: () => import('D:/Repositorys/Unsedang/unsedang-cli/pages/home/sections/LikedCounselors.vue'),
            /* no children */
          },
          {
            path: 'MainBannerCarousel',
            name: '/home/sections/MainBannerCarousel',
            component: () => import('D:/Repositorys/Unsedang/unsedang-cli/pages/home/sections/MainBannerCarousel.vue'),
            /* no children */
          },
          {
            path: 'MiddleGnb',
            name: '/home/sections/MiddleGnb',
            component: () => import('D:/Repositorys/Unsedang/unsedang-cli/pages/home/sections/MiddleGnb.vue'),
            /* no children */
          },
          {
            path: 'NewCounselors',
            name: '/home/sections/NewCounselors',
            component: () => import('D:/Repositorys/Unsedang/unsedang-cli/pages/home/sections/NewCounselors.vue'),
            /* no children */
          },
          {
            path: 'PromoCounselors',
            name: '/home/sections/PromoCounselors',
            component: () => import('D:/Repositorys/Unsedang/unsedang-cli/pages/home/sections/PromoCounselors.vue'),
            /* no children */
          },
          {
            path: 'RecentViewedCounselors',
            name: '/home/sections/RecentViewedCounselors',
            component: () => import('D:/Repositorys/Unsedang/unsedang-cli/pages/home/sections/RecentViewedCounselors.vue'),
            /* no children */
          },
          {
            path: 'ReviewedCounselors',
            name: '/home/sections/ReviewedCounselors',
            component: () => import('D:/Repositorys/Unsedang/unsedang-cli/pages/home/sections/ReviewedCounselors.vue'),
            /* no children */
          },
          {
            path: 'StarCounselorTop5',
            name: '/home/sections/StarCounselorTop5',
            component: () => import('D:/Repositorys/Unsedang/unsedang-cli/pages/home/sections/StarCounselorTop5.vue'),
            /* no children */
          },
          {
            path: 'StarPromoBanner',
            name: '/home/sections/StarPromoBanner',
            component: () => import('D:/Repositorys/Unsedang/unsedang-cli/pages/home/sections/StarPromoBanner.vue'),
            /* no children */
          },
          {
            path: 'WorryCounselorTop5',
            name: '/home/sections/WorryCounselorTop5',
            component: () => import('D:/Repositorys/Unsedang/unsedang-cli/pages/home/sections/WorryCounselorTop5.vue'),
            /* no children */
          }
        ],
      }
    ],
  },
  {
    path: '/join',
    name: '/join',
    component: () => import('D:/Repositorys/Unsedang/unsedang-cli/pages/join.vue'),
    /* no children */
  },
  {
    path: '/login',
    name: '/login',
    component: () => import('D:/Repositorys/Unsedang/unsedang-cli/pages/login.vue'),
    /* no children */
  },
  {
    path: '/loginId',
    name: '/loginId',
    component: () => import('D:/Repositorys/Unsedang/unsedang-cli/pages/loginId.vue'),
    /* no children */
  },
  {
    path: '/mypage',
    /* internal name: '/mypage' */
    /* no component */
    children: [
      {
        path: '',
        name: '/mypage/',
        component: () => import('D:/Repositorys/Unsedang/unsedang-cli/pages/mypage/index.vue'),
        /* no children */
      },
      {
        path: 'account',
        name: '/mypage/account',
        component: () => import('D:/Repositorys/Unsedang/unsedang-cli/pages/mypage/account.vue'),
        /* no children */
      },
      {
        path: 'accountLinkId',
        name: '/mypage/accountLinkId',
        component: () => import('D:/Repositorys/Unsedang/unsedang-cli/pages/mypage/accountLinkId.vue'),
        /* no children */
      },
      {
        path: 'alarmSetting',
        name: '/mypage/alarmSetting',
        component: () => import('D:/Repositorys/Unsedang/unsedang-cli/pages/mypage/alarmSetting.vue'),
        /* no children */
      },
      {
        path: 'chargeCounselPoint',
        name: '/mypage/chargeCounselPoint',
        component: () => import('D:/Repositorys/Unsedang/unsedang-cli/pages/mypage/chargeCounselPoint.vue'),
        /* no children */
      },
      {
        path: 'chargePoint',
        name: '/mypage/chargePoint',
        component: () => import('D:/Repositorys/Unsedang/unsedang-cli/pages/mypage/chargePoint.vue'),
        /* no children */
      },
      {
        path: 'contentBuyHistory',
        name: '/mypage/contentBuyHistory',
        component: () => import('D:/Repositorys/Unsedang/unsedang-cli/pages/mypage/contentBuyHistory.vue'),
        /* no children */
      },
      {
        path: 'couponList',
        name: '/mypage/couponList',
        component: () => import('D:/Repositorys/Unsedang/unsedang-cli/pages/mypage/couponList.vue'),
        /* no children */
      },
      {
        path: 'faq',
        name: '/mypage/faq',
        component: () => import('D:/Repositorys/Unsedang/unsedang-cli/pages/mypage/faq.vue'),
        /* no children */
      },
      {
        path: 'pointDealHistory',
        name: '/mypage/pointDealHistory',
        component: () => import('D:/Repositorys/Unsedang/unsedang-cli/pages/mypage/pointDealHistory.vue'),
        /* no children */
      },
      {
        path: 'profile',
        name: '/mypage/profile',
        component: () => import('D:/Repositorys/Unsedang/unsedang-cli/pages/mypage/profile.vue'),
        /* no children */
      },
      {
        path: 'profileEdit',
        name: '/mypage/profileEdit',
        component: () => import('D:/Repositorys/Unsedang/unsedang-cli/pages/mypage/profileEdit.vue'),
        /* no children */
      },
      {
        path: 'prvcTerm',
        name: '/mypage/prvcTerm',
        component: () => import('D:/Repositorys/Unsedang/unsedang-cli/pages/mypage/prvcTerm.vue'),
        /* no children */
      },
      {
        path: 'ratingComment',
        name: '/mypage/ratingComment',
        component: () => import('D:/Repositorys/Unsedang/unsedang-cli/pages/mypage/ratingComment.vue'),
        /* no children */
      },
      {
        path: 'ratingCommentEdit',
        name: '/mypage/ratingCommentEdit',
        component: () => import('D:/Repositorys/Unsedang/unsedang-cli/pages/mypage/ratingCommentEdit.vue'),
        /* no children */
      },
      {
        path: 'ratingCommentInfo',
        name: '/mypage/ratingCommentInfo',
        component: () => import('D:/Repositorys/Unsedang/unsedang-cli/pages/mypage/ratingCommentInfo.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/offline',
    name: '/offline',
    component: () => import('D:/Repositorys/Unsedang/unsedang-cli/pages/offline.vue'),
    /* no children */
  },
  {
    path: '/passLogin',
    name: '/passLogin',
    component: () => import('D:/Repositorys/Unsedang/unsedang-cli/pages/passLogin.vue'),
    /* no children */
  },
  {
    path: '/qa',
    /* internal name: '/qa' */
    /* no component */
    children: [
      {
        path: '',
        name: '/qa/',
        component: () => import('D:/Repositorys/Unsedang/unsedang-cli/pages/qa/index.vue'),
        /* no children */
      },
      {
        path: 'edit',
        name: '/qa/edit',
        component: () => import('D:/Repositorys/Unsedang/unsedang-cli/pages/qa/edit.vue'),
        /* no children */
      },
      {
        path: 'info',
        name: '/qa/info',
        component: () => import('D:/Repositorys/Unsedang/unsedang-cli/pages/qa/info.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/redirect',
    /* internal name: '/redirect' */
    /* no component */
    children: [
      {
        path: '',
        name: '/redirect/',
        component: () => import('D:/Repositorys/Unsedang/unsedang-cli/pages/redirect/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/search',
    /* internal name: '/search' */
    /* no component */
    children: [
      {
        path: '',
        name: '/search/',
        component: () => import('D:/Repositorys/Unsedang/unsedang-cli/pages/search/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/test',
    name: '/test',
    component: () => import('D:/Repositorys/Unsedang/unsedang-cli/pages/test.vue'),
    /* no children */
  }
]

export function handleHotUpdate(_router, _hotUpdateCallback) {
  if (import.meta.hot) {
    import.meta.hot.data.router = _router
    import.meta.hot.data.router_hotUpdateCallback = _hotUpdateCallback
  }
}

if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    if (!router) {
      import.meta.hot.invalidate('[unplugin-vue-router:HMR] Cannot replace the routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    for (const route of mod.routes) {
      router.addRoute(route)
    }
    // call the hotUpdateCallback for custom updates
    import.meta.hot.data.router_hotUpdateCallback?.(mod.routes)
    const route = router.currentRoute.value
    router.replace({
      ...route,
      // NOTE: we should be able to just do ...route but the router
      // currently skips resolving and can give errors with renamed routes
      // so we explicitly set remove matched and name
      name: undefined,
      matched: undefined,
      force: true
    })
  })
}

